module.exports = __webpack_public_path__ + "static/media/footer-logo.13bc5929.svg";